import { useContext } from "react";
import { udenlandskAdvokatsamfundForm } from "../../../../../config/form/person/stamoplysninger/udenlandskAdvokatsamfundFormConfig";
import { defaultUdenlandskAdvokatsamfundColumns } from "../../../../../config/person";
import { UdenlandskAdvokatsamfundField } from "../../../../../interfaces/personer";
import { PersonDto } from "../../../../../interfaces/schema";
import { IColumn } from "../../../../../interfaces/table";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import ActiveIcon from "../../../../icons/ActiveIcon";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import IngenRegistreringer from "../IngenRegistreringer";
import { UserQueryContext } from "../../../../../context/UserContext";
import { periodeIsActive } from "../../../../../util/date";

export default function UdenlandskAdvokatsamfund({
  person,
  udenlandskAdvokatsamfundColumns,
  setUdenlandskAdvokatsamfundActiveColumns,
}: {
  person: PersonDto;
  udenlandskAdvokatsamfundColumns: IColumn<UdenlandskAdvokatsamfundField>[];
  setUdenlandskAdvokatsamfundActiveColumns: React.Dispatch<
    React.SetStateAction<UdenlandskAdvokatsamfundField[]>
  >;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const isAuth = hasPermission(user, "BasisWrite");

  const { personUdenlandskadvokatsamfund } = person;

  // event handlers
  function downloadHandler() {
    tableToXLSX(
      udenlandskAdvokatsamfundColumns,
      udenlandskAdvokatsamfundColumns,
      {
        fileName: `udenlandskadvokatsamfund-for-${person.kundeNr}`,
        additionalData: {
          kundenr: person.kundeNr,
        },
      },
    );
  }
  if (!personUdenlandskadvokatsamfund?.length) return <IngenRegistreringer />;

  return (
    <>
      <ButtonDownload onClick={downloadHandler} />
      <ModalProvider>
        <TableRoot>
          <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
            <th className="indicator"></th>
            {getHeaderActiveColumns(udenlandskAdvokatsamfundColumns)}
          </TableHead>
          <TableBody>
            {personUdenlandskadvokatsamfund.map((advokatudl) => {
              return (
                <TableRow
                  key={advokatudl.id}
                  editConfig={isAuth ? udenlandskAdvokatsamfundForm : undefined}
                >
                  <td
                    className={`indicator ${
                      periodeIsActive(
                        new Date(advokatudl.periode.fraDato),
                        new Date(advokatudl.periode.tilDatoInklusiv),
                      )
                        ? " has-effect"
                        : ""
                    }  `}
                  >
                    <ActiveIcon />
                  </td>
                  {udenlandskAdvokatsamfundColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return (
                        <TD key={col.field} col={col} rowData={advokatudl} />
                      );
                    })}
                </TableRow>
              );
            })}
          </TableBody>
        </TableRoot>
        <ColumnEditorModal
          columns={udenlandskAdvokatsamfundColumns}
          setActiveColumns={setUdenlandskAdvokatsamfundActiveColumns}
          defaultColumns={defaultUdenlandskAdvokatsamfundColumns}
        />
      </ModalProvider>
    </>
  );
}
